export default __webpack_public_path__ + "static/media/roadmap.60d6dc5c.png";